<template>
  <el-form :model="param" ref="param" style="width: 300px;">
    <el-form-item label="原密码" label-width="78px">
      <el-input type="password" v-model="param.oldPW"></el-input>
    </el-form-item>
    <el-form-item label="新密码" label-width="78px">
      <el-input type="password" v-model="param.newPW"></el-input>
      <div class="tips"><i>密码至少 6 位</i></div>
    </el-form-item>
    <el-form-item label="确认密码" label-width="78px">
      <el-input type="password" v-model="param.conPW"></el-input>
    </el-form-item>
    <el-button type="primary" @click="savePw">确定</el-button>
  </el-form>
</template>

<script>
export default {
  name: "修改密码",
  props: {
    currentUser: {
      type: Object
    }
  },
  data() {
    return {
      param: {}
    }
  },
  methods: {
    savePw() {
      if (!this.param.oldPW) {
        this.$message.error('请输入原密码')
        return
      }
      if (!this.param.newPW) {
        this.$message.error('请输入新密码')
        return
      }
      if (this.param.newPW.length < 6) {
        this.$message.error('密码至少 6 位')
        return
      }
      if (this.param.newPW != this.param.conPW) {
        this.$message.error('两次密码不一致')
        return
      }
      this.$apis.login.resetPw(this.currentUser.sn, this.param).then(response => {
        if (response.status === 200) {
          this.$message({
            message: '修改成功',
            type: 'success'
          })
        }
      })
    }
  },
  created() {

  }
}
</script>

<style scoped>

</style>